import React from 'react'
import { ImageBase } from '../../../../utils/image'
import { GenericPageHeader } from '../../../sharedLayout/pageheader'

type WaitingTimesHeaderProps = {
  image?: ImageBase
  link?: { url: string; title: string }
  breadcrumbs: { url: string; title: string }[]
  title?: string
}

export const WaitingTimesPageHeader = (props: WaitingTimesHeaderProps) => (
  <GenericPageHeader
    kind="waitingTimes"
    breadcrumbs={props.breadcrumbs}
    title={props.title ? 'Wachttijden - ' + props.title : 'Wachttijden'}
    image={props.image}
  />
)
